<script setup lang="ts">
import LeExpandedFooterDesktop from "@/components/footer/LeExpandedFooterDesktop.vue";
import LeExpandedFooterMobile from "@/components/footer/LeExpandedFooterMobile.vue";
import LeSimpleFooter from "@/components/footer/LeSimpleFooter.vue";

interface Props {
  simple?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  simple: false
});
</script>

<template>
  <footer class="le-footer">
    <LeSimpleFooter v-if="props.simple" />
    <template v-else>
      <LeExpandedFooterMobile class="le-footer__mobile" />
      <LeExpandedFooterDesktop class="le-footer__desktop" />
    </template>
  </footer>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-footer {
  &,
  :deep(a) {
    color: @colors[@neutrals][500];
  }

  &__mobile {
    display: block;

    #media-breakpoint-up(lg, {
      display: none;
    });
  }

  &__desktop {
    display: none;

    #media-breakpoint-up(lg, {
      display: block;
    });
  }
}
</style>
